import $ from 'jquery';
import hoverintent from 'hoverintent';

import Component from '../Component';
import { Breakpoints } from '../constants';

/* Place the sale or sold out badge at the top left of preview thumbnail
* image/s, rather than the top left of the containing <div>.
*/
export default class Badge extends Component {
  constructor(theme, element) {
    super(theme, element);
    this.roots = [];
  }

  add = (element, timeout) => {
    this.roots.push(element);
    this.load(element, timeout);
  }

  onWindowResize = () => {
    const $containers = $(this.roots).find('.grid-view-item .grid-view-item-image');
    const $badges = $containers.find('.badge');
    $badges.css('opacity', 0);
    this.calculateBadgePositions($containers);
    $badges.css('opacity', 1);
  }

  load = (element, timeout = undefined) => {
    const badge = this;
    if(timeout === undefined) {
      timeout = 0;
    }

    const $containers = $(element).find('.grid-view-item .grid-view-item-image');
    this.calculateBadgePositions($containers);

    if(timeout > 0) {
      setTimeout(() => {
        this.calculateBadgePositions($containers);
      }, timeout);
    }
  }

  calculateBadgePositions = (container) => {
    container.each((i, el) => {
      $(el).find('*').stop(true, true);
    });
  }
}
